module.exports = __webpack_public_path__ + "assets/img/52323b5f088c880092c498bde2795b55.svg";